import React from 'react';
import { FaEnvelope, FaMobileAlt } from 'react-icons/fa';

const JobCard = ({hiring}) => {
    const establishmentName = hiring?.establisment?.name || "N/A";
    const contactEmail = hiring?.location_id?.email || "N/A";
    const contactNumber = hiring?.location_id?.contact || "N/A";
    const jobCategory = hiring?.job_category || "N/A";
    const skill = hiring?.skill || "N/A";
    const hiringCount = hiring?.no_of_hiring ?? "N/A";
    const locationText = [hiring?.location, hiring?.state].filter(Boolean).join(", ") || "N/A";

    return (
        <div className="card border shadow-sm">
            <div className="card-body">
                {/* Employee Info */}
                <h4 className="card-title text-success mb-0">{jobCategory}</h4>
                <p className="text-muted small mb-0">{establishmentName}</p>
            </div>
            <hr className='m-0' />
            
            {/* Contact Details */}
            <div className="card-body">
                <div className="text-start small text-secondary">
                    <div className="d-flex align-items-center justify-content-start w-full">
                        <div>
                          <FaEnvelope className="me-2 text-muted" />
                        </div>
                        <div className='card_email_div'>
                          <p >{contactEmail}</p>
                        </div>
                    </div>
                    <div className="d-flex align-items-center mt-2">
                        <div>
                          <FaMobileAlt className="me-2 text-muted" />
                        </div>
                        {contactNumber}
                    </div>
                    {/* <p className="d-flex align-items-center mt-2">
                        <div>
                          <MdDateRange className="me-2 text-muted" />
                        </div>
                        {props.employee.dateOfJoining.split('T')[0]}
                        19-09-2024
                    </p> */}
                    <p className="mt-2">
                        <strong>Skill: </strong> {skill}
                    </p>
                    <p className="mt-2">
                        <strong>Hirings: </strong> {hiringCount}
                    </p>
                    <p className="mt-2">
                        <strong>{locationText}</strong>
                    </p>
                    {/* <div className="d-flex justify-content-center mt-3">
                        <button onClick={() => props.employeeProfile(props.employee.employeeId)} className="btn btn-primary">
                            View Detail
                        </button>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default JobCard;
